import { stringify } from "qs";

/**
 * Téléchargement natif via une ancre : le navigateur gère la progression et l'annulation, et nomme le
 * fichier d'après le Content-Disposition.
 * @param {string} url
 * @param {object} [query]
 **/
function downloadUrl(url, query) {
  const queryString = query ? stringify(query) : "";
  const a = document.createElement("a");
  a.href = queryString ? `${url}?${queryString}` : url;
  a.download = "";
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  useMessageStore().i18nMessage("info", "common.downloadPreparing", undefined, 4000);
}

export default downloadUrl;
